import { api } from '@marketplace-web/core-api/core-api-client-util'

import { SellerBadgesListResp, SellerBadgesResp } from '../types/seller-badge'
import {
  GetCategoryTipsResp,
  GetSellerInsightsPhotoRecommendationsResp,
  GetSellerInsightsResp,
} from '../types/seller-insights'

export const getCategoryTips = () => api.get<GetCategoryTipsResp>('/seller_insights/category_tips')

export const getSellerBadgesList = (userId: number) =>
  api.get<SellerBadgesListResp>(`/seller_badges_list/${userId}`)

export const getSellerInsightsPhotoRecommendations = () =>
  api.get<GetSellerInsightsPhotoRecommendationsResp>('/seller_insights/recommendations/add_photos')

export const getSellerInsights = () =>
  api.get<GetSellerInsightsResp>('/seller_insights/closet_stats')

export const getSellerBadges = () => api.get<SellerBadgesResp>('/seller_badges')
